"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteFieldLogic = void 0;
var vote_fieldtype_1 = require("./vote.fieldtype");
Object.defineProperty(exports, "VoteFieldLogic", { enumerable: true, get: function () { return vote_fieldtype_1.VoteFieldLogic; } });
